<div class="caja"
    [class.seleccionada]="seleccionada"
    [class.deshabilitada]="deshabilitada"
    (click)="seleccionar()">
    <small><small>{{ 'SALUD.RECOMENDADOR.LABEL_OPCION.SELECCIONA' | translate }}</small></small>
    <h5>{{ ('SALUD.RECOMENDADOR.LABEL_OPCION.' + opcion.codCategoria + '_' + opcion.titulo + '_TITULO') | translate }}</h5>
    <div *ngIf="(
       ('SALUD.RECOMENDADOR.LABEL_OPCION.' + opcion.codCategoria + '_' + opcion.titulo + '_DESCRIPCION')| translate) 
       !== ('SALUD.RECOMENDADOR.LABEL_OPCION.' + opcion.codCategoria + '_' + opcion.titulo + '_DESCRIPCION')">
         <p >{{ ('SALUD.RECOMENDADOR.LABEL_OPCION.' + opcion.codCategoria + '_' + opcion.titulo + '_DESCRIPCION') | translate }}</p>
    </div>
</div>